import React from 'react';
import { API_URL, downloadAuthenticatedFile } from '../../config/api';

const AssetDetailModal = ({ isOpen, asset, onClose }) => {
  if (!isOpen || !asset) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-slate-900/60 backdrop-blur-xs flex items-center justify-center p-4">
      <div className="fixed inset-0" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden z-10 animate-fadeIn text-slate-800">
        <div className="p-4 px-5 border-b border-slate-100 bg-blue-600 text-white flex items-center justify-between">
          <div>
            <h3 className="text-base font-bold">{asset.name}</h3>
            <p className="text-[11px] text-blue-100 font-mono">Serial: {asset.serial_number || 'N/A'}</p>
          </div>
          <button
            onClick={onClose}
            className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-xs"
          >
            ✕
          </button>
        </div>

        <div className="p-5 space-y-4 text-xs max-h-[80vh] overflow-y-auto">
          <div className="space-y-1">
            <h4 className="text-sm font-bold text-slate-900">Equipment Overview</h4>
            <p className="text-slate-600 leading-relaxed whitespace-pre-wrap">{asset.description || 'No description provided.'}</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 p-3.5 rounded-xl bg-slate-50 border border-slate-200/80">
            <div>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">Asset Type</span>
              <span className="font-bold text-slate-900 capitalize">{asset.asset_type || 'General'}</span>
            </div>
            <div>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">Value (₹)</span>
              <span className="font-bold text-slate-900">₹{(asset.value || 0).toLocaleString()}</span>
            </div>
            <div>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">Serial Number</span>
              <span className="font-bold text-slate-900 font-mono">{asset.serial_number || 'N/A'}</span>
            </div>
            <div>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">Assigned User</span>
              <span className="font-bold text-slate-900">{asset.assigned_to_username || 'Unassigned'}</span>
            </div>
            <div>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">Created At</span>
              <span className="font-bold text-slate-900">{new Date(asset.created_at).toLocaleDateString()}</span>
            </div>
          </div>

          {asset.media_url && (
            <div className="p-3.5 rounded-xl bg-slate-50 border border-slate-200/80 space-y-2.5">
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">Asset Photo</span>
              <img
                src={`${API_URL}${asset.media_url}`}
                alt="Asset"
                className="max-h-64 rounded-xl border border-slate-200 shadow-2xs object-contain"
              />
              <div className="flex gap-2">
                <button
                  onClick={() => window.open(`${API_URL}${asset.media_url}`, '_blank')}
                  className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg text-xs transition-colors shadow-2xs"
                >
                  View Full Image
                </button>
                <button
                  onClick={() => downloadAuthenticatedFile(asset.media_url, `asset-${asset.id}-photo`)}
                  className="px-3 py-1.5 bg-slate-200 hover:bg-slate-300 text-slate-800 font-bold rounded-lg text-xs transition-colors shadow-2xs"
                >
                  Download
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssetDetailModal;
